import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import Editor from "../../../../components/editor/CkEditor";
import { getLanguageDetails } from "../../../../redux/actions/campaignActions";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
// import "../Add/addnew.scss";

const Editlanguage = () => {
  const [contents, setContents] = useState("");
  const [loading, setLoading] = useState(false);
  const id = useParams();

  let token = localStorage.getItem("accessToken");
  const navitage = useNavigate();
  const dispatch = useDispatch();
  const languageView = useSelector((state) => state.languageView);
  const { language } = languageView;

  useEffect(() => {
    dispatch(getLanguageDetails(token, id));
  }, [dispatch]);


  useEffect(() => {
    if (languageView) {
      if (languageView?.loading !== undefined) {
        setLoading(languageView?.loading);
      }
    }
  }, [languageView]);

  useEffect(() => {
    if (language) {
      setValue("section", language?.data?.section);
      setValue("key", language?.data?.key);
      setValue("englishcontent", language?.data?.english);
      setValue("frenchcontent", language?.data?.french);

    }
  }, [language]);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const onSubmit = (data) => {
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "languages-text",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id.langId,
        section: data.section,
        key: data.key,
        english: data.englishcontent,
        french: data.frenchcontent 
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status === 200) {
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navitage("/language");
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">Edit Content</div>
            <p>&nbsp;</p>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="custome-form-group">
                <label>Page Section</label>
                <input
                  type="text"
                  name="section"
                  {...register("section", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.section && (
                  <div className="invalid-feedback">{errors.section.message}</div>
                )}
              </div>
              <div className="custome-form-group">
                <label>Page Key</label>
                <input
                  type="text"
                  name="key"
                  {...register("key", {
                    required: "This field is required",
                  })}
                  className="custome-input"
                />
                {errors.key && (
                  <div className="invalid-feedback">{errors.key.message}</div>
                )}
              </div>
              <div className="custome-form-group">
                <label>English Content</label>
                {getValues("englishcontent") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      getValues("englishcontent") !== undefined
                        ? getValues("englishcontent")
                        : "loading"
                    }
                    name="englishcontent"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("englishcontent", editor.getData());
                    }}
                  />
                )}
              </div>
              <div className="custome-form-group">
                <label>French Content</label>
                {getValues("frenchcontent") !== undefined && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      getValues("frenchcontent") !== undefined
                        ? getValues("frenchcontent")
                        : "loading"
                    }
                    name="frenchcontent"
                    onChange={(e, editor) => {
                      const data = editor.getData();
                      setValue("frenchcontent", editor.getData());
                    }}
                  />
                )}
              </div>
              <button type="submit" className="approveButton">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editlanguage;
